/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        13/02/2020 16:02
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Ux from './ux';


export default class Socials {
    
    constructor()
    {
        Socials.initialize_instagram();
    }

    static initialize_instagram() {

        let $wrapper = $('[data-instagram-wall]');

        if ($wrapper.length > 0) {
            self = this;
            $.ajax({
                url: Theme.ajaxURL,
                data: {
                    'action': 'social_wall',
                },
                type: 'POST',
                success: function (socialData) {
                    $wrapper.append(socialData);
                }
            });
        }
    }
}